import { Button, IconButton } from '@mui/material';
import './quercusMobile.css';
import ilexPyramid from "../../../../../assets/quercus/ilex-pyramid.jpg";
import ilexPyramid1 from "../../../../../assets/quercus/Ilex-aquifolium-sm.jpeg";
import ilexPyramid2 from "../../../../../assets/quercus/Ilex-aquifolium-md.jpeg";
import ilexPyramid3 from "../../../../../assets/quercus/Ilex-aquifolium-lg.jpeg";

import ilexBoule from "../../../../../assets/quercus/ilex-boule.jpg";
import ilexBoule1 from "../../../../../assets/quercus/ilex-boule1.jpeg";

import ilexTige from "../../../../../assets/quercus/ilex-tige.jpg";
import ilexTige1 from "../../../../../assets/quercus/ilex-tige1.jpeg";


import nellieBoule from "../../../../../assets/quercus/nellie-boule.jpg";
import nellieBoule1 from "../../../../../assets/quercus/nellie-boule-sm.jpeg";
import nellieBoule2 from "../../../../../assets/quercus/nellie-boule-md.jpeg";
import nellieBoule3 from "../../../../../assets/quercus/nellie-boule-lg.jpeg";

import nellieHalf from "../../../../../assets/quercus/nellie-half-tige.jpg";
import nellieHalf1 from "../../../../../assets/quercus/nellie-half-tige-sm.jpeg";
import nellieHalf2 from "../../../../../assets/quercus/nellie-half-tige-md.jpeg";
import nellieHalf3 from "../../../../../assets/quercus/nellie-boule-lg.jpeg";

import nellieTige from "../../../../../assets/quercus/nellie-tige.jpg";
import nellieTige1 from "../../../../../assets/quercus/nellie-tige1.jpeg";

import nelliePy1 from "../../../../../assets/quercus/nellie-pyramid-md.jpeg";
import nelliePy2 from "../../../../../assets/quercus/nellie-pyramid-xl.jpeg";

import aquifHalfTige from "../../../../../assets/quercus/illex-aquif-half.jpeg";
import aquifBoule from "../../../../../assets/quercus/illex-aquif-boule.jpeg";

import ilexCornuta from "../../../../../assets/quercus/cornuta.webp";
import ilexCornuta1 from "../../../../../assets/quercus/illex-cornuta.jpeg";

import quercusIlex1 from "../../../../../assets/quercus/quercus-ilex-sm.jpeg";
import quercusIlex2 from "../../../../../assets/quercus/quercus-ilex-md.jpeg";
import quercusIlex3 from "../../../../../assets/quercus/quercus-ilex-lg.jpeg";

import quercusSpecimen1 from "../../../../../assets/quercus/quercus-specimen1.jpeg";
import quercusSpecimen2 from "../../../../../assets/quercus/quercus-specimen2.jpeg";
import quercusSpecimen3 from "../../../../../assets/quercus/quercus-specimen3.jpeg";
import quercusSpecimen4 from "../../../../../assets/quercus/quercus-specimen4.jpeg";

import quercusSuber1 from "../../../../../assets/quercus/quercus-subra-sm.jpeg";
import quercusSuber2 from "../../../../../assets/quercus/quercus-subra-md.jpeg";
import quercusSuber3 from "../../../../../assets/quercus/quercus-subra-lg.jpeg";

import quercusRubra from "../../../../../assets/quercus/quercus-rubra.jpg";
import quercusRubra1 from "../../../../../assets/quercus/quercus-rubra1.jpeg";





import BackIcon from '../../../../../components/back/back';
import { useNavigate } from 'react-router-dom';

type GalleryImage = {
    src: string;
    size?: string;
    name?: string;
};


type QuercusFamily = {
    id: number;
    name: string;
    img: string;
    description: string;
    gallery: GalleryImage[];
};

export const QuercusFamilies: QuercusFamily[] = [
    {
        id: 1,
        name: "ilex aquifolium marginata ",
        img: ilexPyramid,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: ilexPyramid1, size: "small" },
            { src: ilexPyramid2, size: "medium" },
            { src: ilexPyramid3, size: "large" },
        ],
    },
    {
        id: 2,
        name: "ilex aquifolium marginata Boule",
        img: ilexBoule,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: ilexBoule1 },

        ],
    },
    {
        id: 3,
        name: "ilex aquifolium marginata Tige",
        img: ilexTige,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: ilexTige1 },

        ],
    },
    {
        id: 4,
        name: "Ilex Nellie Stevens Boule ",
        img: nellieBoule,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: nellieBoule1, size: "small" },
            { src: nellieBoule2, size: "medium" },
            { src: nellieBoule3, size: "large" },
        ],
    },
    {
        id: 10,
        name: "Ilex Nellie Stevens Pyramid ",
        img: nelliePy1,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: nelliePy1, size: "medium" },
            { src: nelliePy2, size: "large" },

        ],
    },
    {
        id: 5,
        name: "Ilex Nellie Stevens half Tige",
        img: nellieHalf,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: nellieHalf1, size: "small" },
            { src: nellieHalf2, size: "medium" },
            { src: nellieHalf3, size: "large" },

        ],
    },
    {
        id: 6,
        name: "Ilex Nellie Stevens Tige",
        img: nellieTige,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: nellieTige1 },

        ],
    },
    {
        id: 7,
        name: "ilex aquifolium half tige",
        img: nellieHalf,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: aquifHalfTige },

        ],
    },
    {
        id: 8,
        name: "ilex aquifolium Boule",
        img: nellieHalf,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: aquifBoule },

        ],
    },
    {
        id: 9,
        name: "ilex cornuta ",
        img: ilexCornuta,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: ilexCornuta1 },

        ],
    },
    {
        id: 11,
        name: "Quercus Ilex",
        img: nellieHalf,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: quercusIlex1, size: "small" },
            { src: quercusIlex2, size: "medium" },
            { src: quercusIlex3, size: "large" },

        ],
    },
    {
        id: 12,
        name: "Quercus specimen",
        img: quercusSpecimen2,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: quercusSpecimen1 },
            { src: quercusSpecimen2 },
            { src: quercusSpecimen3 },
            { src: quercusSpecimen4 },

        ],
    },
    {
        id: 13,
        name: "Quercus Suber",
        img: quercusSuber1,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: quercusSuber1, size: "small" },
            { src: quercusSuber2, size: "medium" },
            { src: quercusSuber3, size: "large" },

        ],
    },
        {
        id: 14,
        name: "Quercus Rubra",
        img: quercusRubra,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: quercusRubra1 },
          

        ],
    },

];





export default function QuercusMobile() {
    const navigate = useNavigate();

    const handleClick = (name: any) => {
        navigate(`/quercus/${name}`);
    };

    return (
        <div className="ficus-container-mobile">
            <BackIcon />
            <div className="title-overlay" style={{ marginTop: "1rem" }}>
                <h1 className="title-modern-mobile">Quercus Collection</h1>
            </div>
            <div className="plants-category-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" >
                {QuercusFamilies.map((quercus) => (
                    <div key={quercus.id} onClick={() => handleClick(quercus.name)} className=" ficus-shape-card bg-white p-6 rounded-xl shadow-lg transform transition-all hover:scale-105">
                        <img
                            src={quercus.img}
                            alt={quercus.name}
                            className="w-full h-60 object-cover rounded-lg mb-4"
                        />
                        <p className="plant-name">{quercus.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
